const IsAuth = () => {
  return localStorage.getItem('accessToken');
};

export default IsAuth;
